import {Box, Typography} from '@mui/material';
import './BasicInfo.scss';
import {t} from 'i18next';
import ArrTextField from '../../../../common/arr-text-field/ArrTextField';
import {useState} from 'react';
import ArrMultiSelectDropdown from '../../../../common/arr-select-dropdown/ArrMultiSelectDropdown';
import {ISelectItem} from '../../../../../shared/types';
import {useDispatch, useSelector} from 'react-redux';
import {setCreateCustomIndex} from '../../../../../redux/slice/createCustomIndexSlice';
import {RootState} from '../../../../../redux/store';
const options = [
  {
    id: 1,
    name: 'value 1',
  },
  {
    id: 2,
    name: 'value 2',
  },
  {
    id: 3,
    name: 'value 3',
  },
  {
    id: 4,
    name: 'value 4',
  },
  {
    id: 5,
    name: 'value 5',
  },
];

const BasicInfo = () => {
  const dispatch = useDispatch();
  const {createCustomIndex, isReadOnlyView} = useSelector(
    (state: RootState) => state.indexManagement
  );
  const [customIndexName, setCustomIndexName] = useState<string>(
    createCustomIndex?.IndexName ?? ''
  );
  const [customIndexErrorMessage, setCustomIndexErrorMessage] =
    useState<string>('');
  const [securityGroups, setSecurityGroups] = useState<ISelectItem[]>([]);
  const handleSecurityGroups = (selected: ISelectItem[]) => {
    setSecurityGroups(selected);
    const securityGroupIds = selected
      .map((item) => item.id)
      .filter((id): id is number => typeof id === 'number');
    dispatch(setCreateCustomIndex({SecurityGroupIds: securityGroupIds}));
  };

  const handleCustomIndexName = (customName: string) => {
    const regex = /^[a-zA-Z0-9]*$/;

    setCustomIndexName(customName);

    if (!regex.test(customName)) {
      setCustomIndexErrorMessage(
        t('indexManagement.customIndex.basicInfo.nameValidationMsg')
      );
      dispatch(setCreateCustomIndex({IndexName: ''}));
    } else {
      setCustomIndexErrorMessage('');
      dispatch(setCreateCustomIndex({IndexName: customName}));
    }
  };

  const getState = () => {
    if (isReadOnlyView) {
      return 'inactive';
    }
    return customIndexErrorMessage ? 'error' : 'enabled';
  };

  return (
    <Box className="basic-info-main">
      <Box className="basic-info-container">
        <Box className="basic-info-title">
          <Typography
            className="typo-text subhead2_size title-text"
            data-testid={`basic-info-title`}>
            {t('indexManagement.customIndex.basicInfo.title')}
          </Typography>
        </Box>
        <Box className="basic-info-content">
          <Box className="text-container">
            <Box className="name-text-title">
              <Typography
                className="typo-text subhead3_size name-text"
                data-testid={`basic-info-enter-name`}>
                {t('indexManagement.customIndex.basicInfo.enterName')}
                {!isReadOnlyView && <span className="required-text" data-testid={`basic-info-`}>*</span>}
              </Typography>
              <Typography
                className="typo-text body3_size name-index-text"
                data-testid={`basic-info-name-the-index`}>
                {t('indexManagement.customIndex.basicInfo.nameTheIndex')}
              </Typography>
            </Box>
            <ArrTextField
              className="custom-index-field"
              state={getState()}
              tabIndex={isReadOnlyView ? 0 : undefined}
              value={customIndexName}
              onChange={(e) => handleCustomIndexName(e.target.value)}
              placeholder={t('indexManagement.customIndex.basicInfo.name')}
              supportText={
                customIndexErrorMessage
                  ? customIndexErrorMessage
                  : t('indexManagement.customIndex.basicInfo.inputSupportText')
              }
              dataTestId="basic-info-number-to-assign"
              slotProps={{
                inputLabel: {shrink: false},
                input: {
                  inputProps: {
                    maxLength: 50,
                  },
                },
              }}
            />
          </Box>
          <Box className="dropdown-container">
            <Box className="name-text-title">
              <Typography
                className="typo-text subhead3_size name-text"
                data-testid={`basic-info-select-security-group`}>
                {t('indexManagement.customIndex.basicInfo.selectSecurityGroup')}
              </Typography>
              <Typography
                className="typo-text body3_size name-index-text"
                data-testid={`basic-info-control-text`}>
                {t('indexManagement.customIndex.basicInfo.controlText')}
              </Typography>
            </Box>
            <ArrMultiSelectDropdown
              dropdownLabel={t(
                'indexManagement.customIndex.basicInfo.selectSecurityGroup'
              )}
              dropdownItems={options}
              selectedValues={securityGroups}
              onSelectionChange={handleSecurityGroups}
              multiple
              searchable
              tabIndex={isReadOnlyView ? 0 : undefined}
              withControls
              checkboxDataTestId="custom-index-basic-info-security-group-dropdown-checkbox"
              onClearAll={() => {}}
              onApply={() => {}}
              isShowTooltip={false}
              disabled={isReadOnlyView}
              dataTestId="msd-select-security-group"
            />
            <Box className="project-admin-container">
              <Typography
                className="typo-text subhead5_size name-text"
                data-testid={`basic-info-project-admin`}>
                {t('indexManagement.customIndex.basicInfo.projectAdmin')}
              </Typography>
              <Typography
                className="typo-text body3_size name-index-text"
                data-testid={`basic-info-project-admin-content`}>
                {t('indexManagement.customIndex.basicInfo.projectAdminContent')}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BasicInfo;
